import { ConnectButton } from '@rainbow-me/rainbowkit';
import '../App.css';
import { useAccount } from 'wagmi';

function ClaimBtn() {
    return (
        <button className='btn mt-05 btn-riv-primary whitespace-nowrap' type="button">
            Claim All 
        </button>
    );
}

export default ClaimBtn;